import React, { useCallback } from 'react';
import { Page } from 'react-pdf';
import type { PageCallback } from 'react-pdf/dist/cjs/shared/types';

import { ESignPageDimensions } from './types';

interface ESignPdfPageProps {
  pageNumber: number;
  width: number;
  onRenderSuccess: (pageNumber: number, width: number, height: number) => void;
  pageDimensions: ESignPageDimensions | undefined;
  renderOverlay?: (
    pageNumber: number,
    dimensions: ESignPageDimensions
  ) => React.ReactNode;
}

export function ESignPdfPage({
  pageNumber,
  width,
  onRenderSuccess,
  pageDimensions,
  renderOverlay
}: ESignPdfPageProps) {
  const handleRenderSuccess = useCallback(
    (page: PageCallback) => {
      onRenderSuccess(pageNumber, page.width, page.height);
    },
    [pageNumber, onRenderSuccess]
  );

  return (
    <div style={{ position: 'relative', marginBottom: 4 }}>
      <Page
        pageNumber={pageNumber}
        width={width}
        renderTextLayer={false}
        renderAnnotationLayer={false}
        onRenderSuccess={handleRenderSuccess}
      />
      {pageDimensions && renderOverlay && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: pageDimensions.renderedWidth,
            height: pageDimensions.renderedHeight,
            pointerEvents: 'none'
          }}
        >
          {renderOverlay(pageNumber, pageDimensions)}
        </div>
      )}
    </div>
  );
}
